import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { Link } from 'react-router-dom';

export const MarkerWithInfoWindow = (props) => {
    const { title, address, date, showInfoWindow, lat, lng, locationIndex } = props;
    const [markerRef, marker] = useAdvancedMarkerRef();

    return (
        <>
            <AdvancedMarker ref={markerRef} {...props} />
            {showInfoWindow ? (
                <InfoWindow className="info-window" headerContent={`Location #${locationIndex+1} of 19`} anchor={marker} {...props}>
                    <h4>{title}</h4>
                    <h5>{address}</h5>
                    <p>{date}</p>
                    <p><a href={`https://www.google.com/maps/dir/to/${lat},${lng}`} target="_blank" rel="noreferrer">Directions to here</a><i className="bi bi-box-arrow-up-right"></i></p>
                    <p><Link to={`/location/${locationIndex + 1}`} className="btn btn-primary" onClick={() => {
                        document.documentElement.scrollTo({
                            top: 0,
                            left: 0,
                        });
                    }}>More Info</Link></p>
                </InfoWindow>
            ) : null}
        </>
    );
};
